import { render, staticRenderFns } from "./manualContainer.vue?vue&type=template&id=271d2115&scoped=true"
import script from "./manualContainer.vue?vue&type=script&lang=js"
export * from "./manualContainer.vue?vue&type=script&lang=js"
import style0 from "./manualContainer.vue?vue&type=style&index=0&id=271d2115&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271d2115",
  null
  
)

export default component.exports